import React, { useState } from 'react';
import './Formulaire.css';

const Formulaire = () => {
  const [messageSent, setMessageSent] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = (formData) => {
    const newErrors = {};
    if (!formData.get('nom')) newErrors.nom = 'Le nom est requis';
    if (!formData.get('email')) {
      newErrors.email = 'L\'email est requis';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.get('email'))) {
      newErrors.email = 'L\'email est invalide';
    }
    if (!formData.get('telephone')) newErrors.telephone = 'Le téléphone est requis';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

function handleSubmit(event) {
    event.preventDefault(); // Empêche la redirection par défaut

    const form = event.target; // Récupère le formulaire
    const formData = new FormData(form); // Récupère les données du formulaire

    // Envoie les données avec Fetch
    fetch(form.action, {
        method: form.method,
        body: formData,
        headers: {
            'Accept': 'application/json',
        },
    })
        .then(response => {
            if (response.ok) {
                alert("Votre message a été envoyé avec succès ! Merci de m'avoir contacté."); // Affiche une alerte
                form.reset(); // Réinitialise le formulaire
            } else {
                alert("Une erreur est survenue. Veuillez réessayer."); // Alerte en cas d'échec
            }
        })
        .catch(() => {
            alert("Une erreur réseau est survenue. Veuillez vérifier votre connexion."); // Alerte en cas de problème réseau
        });
}

  return (
    <div className='bodyForm' id='contacts'>
      {/* <form className="formulaire" onSubmit={handleSubmit}> */}
      <form
        method="POST"
        action="https://formspree.io/f/xrbyldaz"
        className="formulaire"
>
        <div>
          <h2>Demande de renseignements:</h2>
        </div>
        <div>
          <label htmlFor="nom">Nom:</label>
          <input type="text" id="nom" name="nom" required/>
          {errors.nom && <span className="error-message">{errors.nom}</span>}
        </div>
        <div>
          <label htmlFor="prenom">Prénom:</label>
          <input type="text" id="prenom" name="prenom" required />
        </div>
        <div>
          <label htmlFor="telephone">Téléphone:</label>
          <input type="text" id="telephone" name="telephone" required />
          {errors.telephone && <span className="error-message">{errors.telephone}</span>}
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input type="email" id="email" name="email" required/>
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>
        <div>
          <label htmlFor="codePostale">Code Postale de l'évènement:</label>
          <input type="text" id="codePostale" name="codePostale" required/>
        </div>
        <div>
          <label htmlFor="ville">Ville de l'évènement:</label>
          <input type="text" id="ville" name="ville" required/>
        </div>

        <div>
          <label htmlFor="nombrePersonne">Nombre de personnes:</label>
          <input type="number" id="nombrePersonne" name="nombrePersonne" required/>
        </div>

        <div>
        <label>Date de l'évènement</label>
        <input type='date' required/>
        </div>

        <div>
          <label>Type d'évènement</label>
            <select name="TypeEvent" id="event-select" required>
              <option value="">--Veuillez choisir une option--</option>
              <option value="particulier">Particulier</option>
              <option value="asso">Associations</option>
              <option value="entreprise">Entreprises</option>
            </select> 
        </div>

        <div>
          <label htmlFor="message">Message:</label>
          <textarea id="message" name="message" required/>
        </div>
        <button type="submit" className='buttonForm' disabled={isSubmitting}>
          {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
        </button>
        {messageSent && <div className="success-message">Votre message a été envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.</div>}
      </form>
    </div>
  );
};

export default Formulaire;
